import React from "react";
import InfoNotificationView from "../..";

import "./styles.css";

/**
 * @function InfoAlertNotificationView
 * @param {STRING} text - Sets the info text for the component.
 * @exported true
 * @returns {React.Component}
 * @description - This is a variaiton of the InfoNotificationView. It has blue text, a blue background, with a blue icon.
 * @example
 * <InfoAlertNotificationView text="This is my text" />
 */
export default function InfoAlertNotificationView(props){
  // Any biller name or page name will need the bold-text className applied
  const text = props.text ?? "[text]";

  return (
    <InfoNotificationView className={ `info-alert-notification-view ${ props.className }` } text={ text } textClass="blue-text" />
  );
}